import React from 'react';
import { Container, Typography } from '@sm/wds-react';
import { SignInTextCardSkeletonLoader } from './SignInTextCardSkeleton';
import './sign-in-text-card.scss';

export type SignInTextCardProps = {
  headline: string;
  message: string;
  image: () => React.ReactElement;
  loading?: boolean;
};

export const SignInTextCard: React.FC<SignInTextCardProps> = ({
  headline,
  message,
  image,
  loading,
}) => {
  const templateClass = 'sm-sign-in-text-card';
  const ImageComponent = image;

  return (
    <Container component="aside" className={templateClass} flex>
      {loading ? (
        <SignInTextCardSkeletonLoader />
      ) : (
        <Container component="header" flex flexDirection="column" p="4">
          <Typography
            data-testid="headline"
            className={`${templateClass}__headline`}
            component="section"
            variant="sectionTitle"
          >
            {headline}
          </Typography>
          <Typography
            data-testid="message"
            className={`${templateClass}__message wds-m-t-4`}
            component="div"
            variant="body"
          >
            {message}
          </Typography>
          <Container
            className={`${templateClass}__img-container`}
            mt="7"
            flex
            flexJustify="center"
          >
            <ImageComponent />
          </Container>
        </Container>
      )}
    </Container>
  );
};

SignInTextCard.defaultProps = {
  loading: false,
};

export default SignInTextCard;
